module.exports = __webpack_public_path__ + "img/warning.c1801fe0.svg";